import _toConsumableArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useRef as $Qsto2$useRef, useState as $Qsto2$useState, useMemo as $Qsto2$useMemo } from "react";
import { useControlledState as $Qsto2$useControlledState } from "@react-stately/utils";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $7af3f5b51489e0b5$exports = {};
$parcel$export($7af3f5b51489e0b5$exports, "useMultipleSelectionState", function () {
  return $7af3f5b51489e0b5$export$253fe78d46329472;
});

var $e40ea825a81a3709$export$52baac22726c72bf = /*#__PURE__*/function (_Set) {
  _inherits($e40ea825a81a3709$export$52baac22726c72bf, _Set);

  function $e40ea825a81a3709$export$52baac22726c72bf(keys, anchorKey, currentKey) {
    var _this;

    _classCallCheck(this, $e40ea825a81a3709$export$52baac22726c72bf);

    _this = _possibleConstructorReturn(this, _getPrototypeOf($e40ea825a81a3709$export$52baac22726c72bf).call(this, keys));

    if (keys instanceof $e40ea825a81a3709$export$52baac22726c72bf) {
      _this.anchorKey = anchorKey || keys.anchorKey;
      _this.currentKey = currentKey || keys.currentKey;
    } else {
      _this.anchorKey = anchorKey;
      _this.currentKey = currentKey;
    }

    return _this;
  }

  return $e40ea825a81a3709$export$52baac22726c72bf;
}(_wrapNativeSuper(Set));

function $7af3f5b51489e0b5$var$equalSets(setA, setB) {
  if (setA.size !== setB.size) return false;

  var _iterator = _createForOfIteratorHelper(setA),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (!setB.has(item)) return false;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
}

function $7af3f5b51489e0b5$export$253fe78d46329472(props) {
  var _props$selectionMode = props.selectionMode,
      selectionMode = _props$selectionMode === void 0 ? 'none' : _props$selectionMode,
      disallowEmptySelection = props.disallowEmptySelection,
      allowDuplicateSelectionEvents = props.allowDuplicateSelectionEvents; // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
  // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).

  var isFocusedRef = $Qsto2$useRef(false);

  var _$Qsto2$useState = $Qsto2$useState(false),
      _$Qsto2$useState2 = _slicedToArray(_$Qsto2$useState, 2),
      _setFocused = _$Qsto2$useState2[1];

  var focusedKeyRef = $Qsto2$useRef(null);
  var childFocusStrategyRef = $Qsto2$useRef(null);

  var _$Qsto2$useState3 = $Qsto2$useState(null),
      _$Qsto2$useState4 = _slicedToArray(_$Qsto2$useState3, 2),
      _setFocusedKey = _$Qsto2$useState4[1];

  var selectedKeysProp = $Qsto2$useMemo(function () {
    return $7af3f5b51489e0b5$var$convertSelection(props.selectedKeys);
  }, [props.selectedKeys]);
  var defaultSelectedKeys = $Qsto2$useMemo(function () {
    return $7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new $e40ea825a81a3709$export$52baac22726c72bf());
  }, [props.defaultSelectedKeys]);

  var _$Qsto2$useControlled = $Qsto2$useControlledState(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange),
      _$Qsto2$useControlled2 = _slicedToArray(_$Qsto2$useControlled, 2),
      selectedKeys = _$Qsto2$useControlled2[0],
      _setSelectedKeys = _$Qsto2$useControlled2[1];

  var disabledKeysProp = $Qsto2$useMemo(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);

  var _$Qsto2$useState5 = $Qsto2$useState(props.selectionBehavior || 'toggle'),
      _$Qsto2$useState6 = _slicedToArray(_$Qsto2$useState5, 2),
      selectionBehavior = _$Qsto2$useState6[0],
      setSelectionBehavior = _$Qsto2$useState6[1]; // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
  // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.


  if (props.selectionBehavior === 'replace' && selectionBehavior === 'toggle' && typeof selectedKeys === 'object' && selectedKeys.size === 0) setSelectionBehavior('replace');
  return {
    selectionMode: selectionMode,
    disallowEmptySelection: disallowEmptySelection,
    selectionBehavior: selectionBehavior,
    setSelectionBehavior: setSelectionBehavior,

    get isFocused() {
      return isFocusedRef.current;
    },

    setFocused: function setFocused(f) {
      isFocusedRef.current = f;

      _setFocused(f);
    },

    get focusedKey() {
      return focusedKeyRef.current;
    },

    get childFocusStrategy() {
      return childFocusStrategyRef.current;
    },

    setFocusedKey: function setFocusedKey(k) {
      var childFocusStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'first';
      focusedKeyRef.current = k;
      childFocusStrategyRef.current = childFocusStrategy;

      _setFocusedKey(k);
    },
    selectedKeys: selectedKeys,
    setSelectedKeys: function setSelectedKeys(keys) {
      if (allowDuplicateSelectionEvents || !$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) _setSelectedKeys(keys);
    },
    disabledKeys: disabledKeysProp
  };
}

function $7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
  if (!selection) return defaultValue;
  return selection === 'all' ? 'all' : new $e40ea825a81a3709$export$52baac22726c72bf(selection);
}

var $d496c0a20b6e58ec$exports = {};
$parcel$export($d496c0a20b6e58ec$exports, "SelectionManager", function () {
  return $d496c0a20b6e58ec$export$6c8a5aaad13c9852;
});

var $d496c0a20b6e58ec$export$6c8a5aaad13c9852 = /*#__PURE__*/function () {
  _createClass($d496c0a20b6e58ec$export$6c8a5aaad13c9852, [{
    key: "setSelectionBehavior",

    /**
    * Sets the selection behavior for the collection.
    */
    value: function setSelectionBehavior(selectionBehavior) {
      this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
    * Whether the collection is currently focused.
    */

  }, {
    key: "setFocused",

    /**
    * Sets whether the collection is focused.
    */
    value: function setFocused(isFocused) {
      this.state.setFocused(isFocused);
    }
    /**
    * The current focused key in the collection.
    */

  }, {
    key: "setFocusedKey",

    /**
    * Sets the focused key.
    */
    value: function setFocusedKey(key, childFocusStrategy) {
      this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
    * The currently selected keys in the collection.
    */

  }, {
    key: "isSelected",

    /**
    * Returns whether a key is selected.
    */
    value: function isSelected(key) {
      if (this.state.selectionMode === 'none') return false;
      key = this.getKey(key);
      return this.state.selectedKeys === 'all' ? !this.state.disabledKeys.has(key) : this.state.selectedKeys.has(key);
    }
    /**
    * Whether the selection is empty.
    */

  }, {
    key: "extendSelection",

    /**
    * Extends the selection to the given key.
    */
    value: function extendSelection(toKey) {
      if (this.selectionMode === 'none') return;

      if (this.selectionMode === 'single') {
        this.replaceSelection(toKey);
        return;
      }

      toKey = this.getKey(toKey);
      var selection; // Only select the one key if coming from a select all.

      if (this.state.selectedKeys === 'all') selection = new $e40ea825a81a3709$export$52baac22726c72bf([toKey], toKey, toKey);else {
        var selectedKeys = this.state.selectedKeys;
        var anchorKey = selectedKeys.anchorKey || toKey;
        selection = new $e40ea825a81a3709$export$52baac22726c72bf(selectedKeys, anchorKey, toKey);

        var _iterator2 = _createForOfIteratorHelper(this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var key = _step2.value;
            selection.delete(key);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var _iterator3 = _createForOfIteratorHelper(this.getKeyRange(toKey, anchorKey)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var key1 = _step3.value;
            if (!this.state.disabledKeys.has(key1)) selection.add(key1);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getKeyRange",
    value: function getKeyRange(from, to) {
      var fromItem = this.collection.getItem(from);
      var toItem = this.collection.getItem(to);

      if (fromItem && toItem) {
        if (fromItem.index <= toItem.index) return this.getKeyRangeInternal(from, to);
        return this.getKeyRangeInternal(to, from);
      }

      return [];
    }
  }, {
    key: "getKeyRangeInternal",
    value: function getKeyRangeInternal(from, to) {
      var keys = [];
      var key = from;

      while (key) {
        var item = this.collection.getItem(key);
        if (item && item.type === 'item' || item.type === 'cell' && this.allowsCellSelection) keys.push(key);
        if (key === to) return keys;
        key = this.collection.getKeyAfter(key);
      }

      return [];
    }
  }, {
    key: "getKey",
    value: function getKey(key) {
      var item = this.collection.getItem(key);
      if (!item) // ¯\_(ツ)_/¯
        return key; // If cell selection is allowed, just return the key.

      if (item.type === 'cell' && this.allowsCellSelection) return key; // Find a parent item to select

      while (item.type !== 'item' && item.parentKey != null) {
        item = this.collection.getItem(item.parentKey);
      }

      if (!item || item.type !== 'item') return null;
      return item.key;
    }
    /**
    * Toggles whether the given key is selected.
    */

  }, {
    key: "toggleSelection",
    value: function toggleSelection(key) {
      if (this.selectionMode === 'none') return;

      if (this.selectionMode === 'single' && !this.isSelected(key)) {
        this.replaceSelection(key);
        return;
      }

      key = this.getKey(key);
      if (key == null) return;
      var keys = new $e40ea825a81a3709$export$52baac22726c72bf(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);
      if (keys.has(key)) keys.delete(key);else {
        keys.add(key);
        keys.anchorKey = key;
        keys.currentKey = key;
      }
      if (this.disallowEmptySelection && keys.size === 0) return;
      this.state.setSelectedKeys(keys);
    }
    /**
    * Replaces the selection with only the given key.
    */

  }, {
    key: "replaceSelection",
    value: function replaceSelection(key) {
      if (this.selectionMode === 'none') return;
      key = this.getKey(key);
      if (key == null) return;
      this.state.setSelectedKeys(new $e40ea825a81a3709$export$52baac22726c72bf([key], key, key));
    }
    /**
    * Replaces the selection with the given keys.
    */

  }, {
    key: "setSelectedKeys",
    value: function setSelectedKeys(keys) {
      if (this.selectionMode === 'none') return;
      var selection = new $e40ea825a81a3709$export$52baac22726c72bf();

      var _iterator4 = _createForOfIteratorHelper(keys),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var key = _step4.value;
          key = this.getKey(key);

          if (key != null) {
            selection.add(key);
            if (this.selectionMode === 'single') break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getSelectAllKeys",
    value: function getSelectAllKeys() {
      var _this2 = this;

      var keys = [];

      var addKeys = function addKeys(key) {
        while (key) {
          if (!_this2.state.disabledKeys.has(key)) {
            var item = _this2.collection.getItem(key);

            if (item.type === 'item') keys.push(key); // Add child keys. If cell selection is allowed, then include item children too.

            if (item.hasChildNodes && (_this2.allowsCellSelection || item.type !== 'item')) addKeys(_toConsumableArray(item.childNodes)[0].key);
          }

          key = _this2.collection.getKeyAfter(key);
        }
      };

      addKeys(this.collection.getFirstKey());
      return keys;
    }
    /**
    * Selects all items in the collection.
    */

  }, {
    key: "selectAll",
    value: function selectAll() {
      if (this.selectionMode === 'multiple') this.state.setSelectedKeys('all');
    }
    /**
    * Removes all keys from the selection.
    */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new $e40ea825a81a3709$export$52baac22726c72bf());
    }
    /**
    * Toggles between select all and an empty selection.
    */

  }, {
    key: "toggleSelectAll",
    value: function toggleSelectAll() {
      if (this.isSelectAll) this.clearSelection();else this.selectAll();
    }
  }, {
    key: "select",
    value: function select(key, e) {
      if (this.selectionMode === 'none') return;

      if (this.selectionMode === 'single') {
        if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);else this.replaceSelection(key);
      } else if (this.selectionBehavior === 'toggle' || e && (e.pointerType === 'touch' || e.pointerType === 'virtual')) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
        this.toggleSelection(key);else this.replaceSelection(key);
    }
    /**
    * Returns whether the current selection is equal to the given selection.
    */

  }, {
    key: "isSelectionEqual",
    value: function isSelectionEqual(selection) {
      if (selection === this.state.selectedKeys) return true; // Check if the set of keys match.

      var selectedKeys = this.selectedKeys;
      if (selection.size !== selectedKeys.size) return false;

      var _iterator5 = _createForOfIteratorHelper(selection),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var key = _step5.value;
          if (!selectedKeys.has(key)) return false;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var _iterator6 = _createForOfIteratorHelper(selectedKeys),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key2 = _step6.value;
          if (!selection.has(key2)) return false;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return true;
    }
  }, {
    key: "canSelectItem",
    value: function canSelectItem(key) {
      if (this.state.selectionMode === 'none' || this.state.disabledKeys.has(key)) return false;
      var item = this.collection.getItem(key);
      if (!item || item.type === 'cell' && !this.allowsCellSelection) return false;
      return true;
    }
  }, {
    key: "selectionMode",

    /**
    * The type of selection that is allowed in the collection.
    */
    get: function get() {
      return this.state.selectionMode;
    }
    /**
    * Whether the collection allows empty selection.
    */

  }, {
    key: "disallowEmptySelection",
    get: function get() {
      return this.state.disallowEmptySelection;
    }
    /**
    * The selection behavior for the collection.
    */

  }, {
    key: "selectionBehavior",
    get: function get() {
      return this.state.selectionBehavior;
    }
  }, {
    key: "isFocused",
    get: function get() {
      return this.state.isFocused;
    }
  }, {
    key: "focusedKey",
    get: function get() {
      return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */

  }, {
    key: "childFocusStrategy",
    get: function get() {
      return this.state.childFocusStrategy;
    }
  }, {
    key: "selectedKeys",
    get: function get() {
      return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
    * The raw selection value for the collection.
    * Either 'all' for select all, or a set of keys.
    */

  }, {
    key: "rawSelection",
    get: function get() {
      return this.state.selectedKeys;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
    * Whether all items in the collection are selected.
    */

  }, {
    key: "isSelectAll",
    get: function get() {
      if (this.isEmpty) return false;
      if (this.state.selectedKeys === 'all') return true;
      if (this._isSelectAll != null) return this._isSelectAll;
      var allKeys = this.getSelectAllKeys();
      var selectedKeys = this.state.selectedKeys;
      this._isSelectAll = allKeys.every(function (k) {
        return selectedKeys.has(k);
      });
      return this._isSelectAll;
    }
  }, {
    key: "firstSelectedKey",
    get: function get() {
      var first = null;

      var _iterator7 = _createForOfIteratorHelper(this.state.selectedKeys),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var key = _step7.value;
          var item = this.collection.getItem(key);
          if (!first || (item === null || item === void 0 ? void 0 : item.index) < first.index) first = item;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return first === null || first === void 0 ? void 0 : first.key;
    }
  }, {
    key: "lastSelectedKey",
    get: function get() {
      var last = null;

      var _iterator8 = _createForOfIteratorHelper(this.state.selectedKeys),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var key = _step8.value;
          var item = this.collection.getItem(key);
          if (!last || (item === null || item === void 0 ? void 0 : item.index) > last.index) last = item;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return last === null || last === void 0 ? void 0 : last.key;
    }
  }]);

  function $d496c0a20b6e58ec$export$6c8a5aaad13c9852(collection, state, options) {
    _classCallCheck(this, $d496c0a20b6e58ec$export$6c8a5aaad13c9852);

    this.collection = collection;
    this.state = state;
    var ref;
    this.allowsCellSelection = (ref = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && ref !== void 0 ? ref : false;
    this._isSelectAll = null;
  }

  return $d496c0a20b6e58ec$export$6c8a5aaad13c9852;
}();

var $63d397230baf7bd4$exports = {};
export { $7af3f5b51489e0b5$export$253fe78d46329472 as useMultipleSelectionState, $d496c0a20b6e58ec$export$6c8a5aaad13c9852 as SelectionManager };